/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { SqlEngine } from '../models/SqlEngine';

export class ListSqlEnginesResponse {
  /**
  * List of SQL engines in the workspace
  */
  'sqlEngines': Array<SqlEngine>;
  'pagination'?: Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sqlEngines",
      "baseName": "sqlEngines",
      "type": "Array<SqlEngine>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSqlEnginesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

